import { COLLECTIONS, PATHS } from '__constants__'
import { generatePath, useNavigate } from 'react-router-dom'
import { useEvent, useTranslations } from 'hooks'

import { deleteDocument } from 'services/api/firebase'
import { message } from 'antd'
import { useMemo } from 'react'

/* Path's */
const createPath =
  PATHS.AUTHENTICATED.REVIEW_CREATE || PATHS.AUTHENTICATED.REVIEW_WIZARD
const editPath = PATHS.AUTHENTICATED.REVIEW_EDIT

const useReviewBaseActions = ({ reviewId, productId, actions } = {}) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()

  /* Function to handle back click */
  const handleBack = useEvent(() => navigate(-1))

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    navigate(createPath)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { reviewId }
    const path = generatePath(editPath, pathParams)
    navigate(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.REVIEWS, reviewId)
      message.success(t('Review successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onEdit: handleEdit,
      onDelete: handleDelete,
      ...(actions || {}),
      createPath,
      editPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      actions?.onOpen,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit
    ]
  )
}

export default useReviewBaseActions
